import axios from "axios";
import { message } from "ant-design-vue"
import { getCookie } from "../utils/cookie";
// axios.defaults.withCredentials = true;
// 缓存Api数据
let cacheApi = {};
// 请求
function request(options) {
  let { cacheBol, url, data } = options;
  let key = data ? `${url}${JSON.stringify(data)}` : url;
  let result = cacheApi[key];
  return new Promise((resolve, reject) => {
    if (cacheBol && result) {
      // console.log("调用缓存Api数据");
      result.code !== 411 ? resolve(result) : (message.error(result.result || result.warning), reject(result));
      return;
    };
    const token = "Bearer " + getCookie("lq-handlephoto-token");
    axios
      .request({
        ...options,
        ...token && {
          headers: {
            Authorization: token
          }
        }
      })
      .then(res => {
        let dt = res.data;
        if (dt.code) {
          if ([dt.code, dt.status].includes(200)) {
            if (cacheBol) {
              cacheApi[key] = dt;
            }
            resolve(dt || res);
          } else if ([String(dt.code)[0], String(dt.status)[0]].includes(4)) {
            if (cacheBol) {
              cacheApi[key] = {
                code: 411,
                ...dt
              };
            }
            message.error(dt.result);
            reject(dt || res)
          } else {
            message.error(dt.warning || dt.result || '发生错误，请联系客服', 3);
            reject(dt.warning || dt.result || '发生错误，请联系客服')
          }
        } else {
          resolve(dt || res)
        }
      }).catch(res => {
        message.error("发生错误，请重新制作或联系客服")
        reject(res);
      });
  });
}
function toFormData(params) {
  const formData = new FormData();
  Object.keys(params).forEach((key) => {
    formData.append(key, params[key]);
  });
  return formData;
}
//url,header,data,cacheBol是否缓存结果
const Get = options => request({ ...options, method: "GET" })
// function Get(options) {
//   let opt = {
//     ...options,
//     method: "GET"
//   };
//   return request(opt);
// }
//url,header,data
function Post(options) {
  let opt = {
    ...options,
    method: "POST"
  };
  return request(opt);
}

function Del(options) {
  let opt = {
    ...options,
    method: "delete"
  };
  return request(opt);
}
const api = {
  getPrice() {
    return Get({
      url: `/official_web/orders/price`,
      cacheBol: true
    });
  },
  getBgColors() {
    return Get({
      url: `/official_web/colors`,
      cacheBol: true
    });
  },
  getClothes() {
    return Get({
      url: "/wechat_applet/business_clothes",
      cacheBol: true
    });
  },
  changeClothes(data) {
    return Post({
      url: "official_web/clothes/preview",
      data,
      // cacheBol: true
    });
  },
  getSearchSpecs(keyword) {
    return Get({
      url: `api/web_specs/${keyword}`
    });
  },
  getSpecsItem(spec_id) {
    return Get({
      url: `api/web_specs_by_id/${spec_id}`
    });
  },
  confirmLogin() {
    return Get({
      url: `/official_web/user`
    });
  },
  wxLogin(data) {
    return Get({
      // url: `/official_web/wechat-login/v2`,
      url: `/official_web/wechat-login`,
      data
    });
  },
  wxLoginHeart(key) {
    return Get({
      url: `/official_web/user/wechat/token/${key}`
    })
  },
  wechatLogin(data) {
    return Post({
      url: `/official_web/wechat-login`,
      data: {
        ...data,
        // app_id: "wxcf49796eb7bfb35d"
        app_id: "wx4081008a719ae217",
        // app_id: "wxa6e696a7948d7f8a"
      }
    });
  },
  aliLogin(data) {
    return Post({
      url: `/official_web/alipay-login`,
      data: {
        ...data,
        app_id: "2021002134660949",
      }
    });
  },
  aliPay(data) {
    return Post({
      url: `official_web/alipay-params`,
      data: { ...data, app_id: "2021002134660949", }
    });
  },
  wxPay(data) {
    return Post({
      url: `official_web/wechat-pay-params`,
      data: { ...data, app_id: "wx4081008a719ae217", }
    });
  },
  cutPic(data) {
    return Post({
      url: `official_web/tailoring`,
      data: data
    });
  },
  getOrders(data) {
    return Get({

      url: `official_web/orders?pic_type=${data.type}`,
      cacheBol: true
    });
  },
  queryOrder(data) {
    return Get({
      url: `official_web/orders/${data}`
    });
  },
  delOrder(data) {
    return Del({
      url: `official_web/orders/${data}`
    });
  },
  getMakerPic(data) {
    return Post({
      url: `official_web/forepic`,
      data: toFormData(data),
      cacheBol: true
    });
  }
};
module.exports = api;
